export default defineNuxtPlugin(() => {
  // Use MutationObserver to timestamp ALL notifications (Main App + Embedded Apps)
  // as they are added to the DOM. This allows us to track freshness universally.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node instanceof HTMLElement &&
          node.classList.contains("el-notification")
        ) {
          if (!node.dataset.timestamp) {
            node.dataset.timestamp = Date.now().toString();
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
